<template>
  <div class="addStock">
    <div class="goods_batch_other goods_batch_type">
      <span class="good_label">选择货主</span>
      <span
        class="good_cli van-ellipsis"
        style="width:50%;text-align:right"
        @click="toSelectSupplier"
      >
        {{subData.supplier_id?subData.supplier_name:'点击选择货主'}}
        <van-icon name="arrow" />
      </span>
    </div>
    <div class="goods_batch_other">
      <span class="good_label">选择类型</span>
      <span class="good_sel">
        <van-radio-group v-model="subData.type" direction="horizontal">
          <van-radio name="1" checked-color="#31B158">自营</van-radio>
          <van-radio name="2" checked-color="#31B158">代卖</van-radio>
        </van-radio-group>
      </span>
    </div>

    <div class="goods_batch_weight goods_input" v-show="subData.supplier_name">
      <span class="good_label">
        批次号
        <span>({{$route.query.item?'不可修改':'可修改'}})</span>
      </span>
      <div class="good_input">
        <input
          type="text"
          v-model="subData.batch"
          :readonly="$route.query.item"
          placeholder="请输入批次号"
          style="width: 100%;"
          :maxlength="20"
        />
      </div>
    </div>
    <van-button
      icon="plus"
      :class="!subData.goods.length?'add_btn':'add_btn_small'"
      type="primary"
      plain
      @click="toAddGoods('addGoods')"
    >添加货品</van-button>
    <div class="goods_list">
      <div class="goods" v-for="(item,i) in subData.goods" :key="i">
        <div class="flex-b">
          <div>
            <span class="goods_name">{{item.name}}</span>
            <div class="good_type good_type_0" v-if="item.bale == 3">
              散装
              <img src="@/assets/img/work/open_order/order/type_sanzhuang.png" alt />
            </div>
            <div class="good_type good_type_1" v-if="item.bale == 1">
              定装
              <img src="@/assets/img/work/open_order/order/type_dingzhuang.png" alt />
            </div>
            <div class="good_type good_type_2" v-if="item.bale == 2">
              非定装
              <img src="@/assets/img/work/open_order/order/type_feidingzhuang.png" alt />
            </div>
          </div>
          <div
            style="text-align:right;font-weight: 700;font-size:0.36rem;color:rgba(51,51,51,1);"
          >￥{{ item|goodsTotalPrice}}</div>
        </div>
        <div>
          <div class="goods_tips">
            <div>分类：{{item.goodsTypeName}}</div>
            <template v-if="item.bale != 1">
              <div>重量：{{item.weight*1}} 公斤</div>
              <div>
                <div v-if="item.bale ==2">数量：{{item.num*1}} {{unit_list[item.num_unit-1].name}}</div>
              </div>
            </template>
            <template v-else>
              <div>规格：{{item.bale_num}} 公斤/{{unit_list[item.num_unit-1].name}}</div>
              <div>数量：{{item.num}} {{unit_list[item.num_unit-1].name}}</div>
            </template>
            <div class="goods_price">
              <div>定价：{{item.proposed_price|numToFixed(2)}}
                <span v-if="item.bale == 1">元/{{unit_list[item.num_unit-1].name}}</span>
                <span v-if="item.bale == 4">元/个</span>
                <span v-if="item.bale == 2 || item.bale == 3">元/公斤</span>
              </div>
              <div>总价：{{item.amount|numToFixed(2)}} 元</div>
              <div v-if="item.surcharge.length">总附加费:{{item|goodsAddition}}元</div>
            </div>
            <div class="btns">
              <van-button
                type="danger"
                color="#FB5353"
                size="small"
                style="border-radius:0.04rem"
                @click="delGoods(i)"
              >删除</van-button>
              <van-button
                color="#31B158"
                type="info"
                size="small"
                style="margin-left:0.2rem;border-radius:0.04rem"
                @click="toAddGoods(i)"
              >修改</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-button
      icon="plus"
      :class="!subData.surcharge.market.length&&!subData.surcharge.place.length?'add_btn':'add_btn_small'"
      type="primary"
      plain
      @click="toAddAddition('addAddition')"
    >添加附加费</van-button>
    <div
      class="addition_boxs"
      v-if="subData.surcharge.place.length||subData.surcharge.market.length"
    >
      <div class="addition_box" v-if="subData.surcharge.place.length">
        <div class="addition_header">产地附加费</div>
        <div class="addition_list">
          <div class="addition_item" v-for="(item,i) in subData.surcharge.place" :key="i">
            <div class="addition_left">{{item.name}}</div>
            <div class="addition_right">￥{{item.price|numToFixed(2)}}</div>
          </div>
        </div>
      </div>
      <div class="addition_box" v-if="subData.surcharge.market.length">
        <div class="addition_header">市场附加费</div>
        <div class="addition_list">
          <div class="addition_item" v-for="(item,i) in subData.surcharge.market" :key="i">
            <div class="addition_left">{{item.name}}</div>
            <div class="addition_right">￥{{item.price|numToFixed(2)}}</div>
          </div>
        </div>
      </div>
      <div class="addition_foot">
        <div class="addition_total">总计:￥{{totalAddition|numToFixed(2)}}</div>
        <div>
          <van-button
            type="danger"
            color="#FB5353"
            size="small"
            style="border-radius:0.04rem"
            @click="delAddition()"
          >删除</van-button>
          <van-button
            color="#31B158"
            type="info"
            size="small"
            style="margin-left:0.2rem;border-radius:0.04rem"
            @click="toAddAddition('eidtAddition')"
          >修改</van-button>
        </div>
      </div>
    </div>
    <div class="img_list">
      <div class="img_title">产地证明</div>
      <div class="img_imgUpload">
        <van-uploader
          :max-count="9"
          v-model="subData.prod_cert_imgs"
          :before-read="beforeReadProd"
          :before-delete="beforeDetaleCredit"
        />
      </div>
    </div>
    <div class="img_list">
      <div class="img_title">销售凭证</div>
      <div class="img_imgUpload">
        <van-uploader
          :max-count="9"
          v-model="subData.bill_cert_imgs"
          :before-read="beforeReadBill"
          :before-delete="beforeDetaleCredit"
        />
      </div>
    </div>

    <div class="bottom_box">
      <div class="bottom_text">总计:￥{{totalPrice|numToFixed(2)}}</div>
      <div class="good_save_btn" @click="setData">确 认</div>
    </div>
  </div>
</template>

<script>
import { uploadImg } from "@/api/public";
import { photoCompress } from "@/utils/photoCompress";
import { stock_new_create, stock_new_batch } from "@/api/work/manage/stock";
export default {
  name: "addStock",
  filters: {
    numToFixed(val, num) {
      //取num位小数点
      val = val * 1;
      return val.toFixed(num * 1);
    },
    goodsAddition(item) {
      // 每个商品的总产品附加
      if (item.surcharge.length) {
        return item.surcharge
          .reduce((total, citem) => {
            return total + citem.price * 1;
          }, 0)
          .toFixed(2);
      }
      return "0.00";
    },
    goodsTotalPrice(item) {
      // 每个货品的价格（含产品附加）
      let total =
        item.amount;
      if (item.surcharge.length) {
        total +=
          item.surcharge.reduce((price, citem) => {
            return price + citem.price * 1;
          }, 0) * 1;
      }
      return total.toFixed(2);
    }
  },
  computed: {
    totalPrice() {
      let totalAddition = this.totalAddition * 1 || 0;
      let totalGoods = this.subData.goods.reduce((price, item) => {
        let goodsPrice = item.amount;
        

        let goodAdditionPrice = 0;
        if (item.surcharge.length) {
          goodAdditionPrice = item.surcharge.reduce((smallPrice, citem) => {
            return smallPrice * 1 + citem.price * 1;
          }, 0);
        }

        return price * 1 + goodsPrice * 1 + goodAdditionPrice * 1;
      }, 0);
      return totalAddition * 1 + totalGoods * 1;
    },
    totalAddition() {
      let obj = this.subData.surcharge;
      let total1 = 0;
      if (obj.market.length) {
        total1 = obj.market.reduce((price, item) => {
          return price + item.price * 1;
        }, 0);
      }

      let total2 = 0;
      if (obj.place.length) {
        total2 = obj.place.reduce((price, item) => {
          return price + item.price * 1;
        }, 0);
      }
      return total1 + total2;
    }
  },
  data() {
    return {
      radio: "1",
      pack_list: [
        { value: 1, name: "定装" },
        { value: 2, name: "非定装" },
        { value: 3, name: "散装" }
      ],
      unit_active: "1",
      isQuery:false,
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      editAddition: false,
      goodsIndex: "", //货品修改索引
      subData: {
        batch: "", //批次号
        type: "1", //1自营，2代卖
        supplier_id: "", // 货主id
        supplier_name: "", // 货主名字
        goods: [],
        surcharge: {
          market: [],
          place: []
        },
        bill_cert_imgs: [], //销售凭证
        prod_cert_imgs: [] //产地证明
      }
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   if (to.query.item) {
  //     to.meta.title = "编辑库存";
  //   } else {
  //     to.meta.title = "添加库存";
  //   }
  //   next();
  // },
  created() {
    // if (this.$route.query.item) {
    //   this.$route.meta.title = "编辑库存";
    //   this.subData = JSON.parse(decodeURI(this.$route.query.item));
    //   this.subData.supplier_name = this.subData.supplier.name;
    //   delete this.subData.supplier;
    //   delete this.subData.uid;
    //   this.subData.weight = Number(Number(this.subData.weight).toFixed(3));
    //   this.subData.bale_num = Number(Number(this.subData.bale_num).toFixed(3));
    //   this.subData.num = Number(Number(this.subData.num).toFixed(3));
    //   this.subData.price = Number(Number(this.subData.price).toFixed(3));
    // } else {
    //   this.$route.meta.title = "新增库存";
    // }

    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "manage_owner_ownerManage") {
        if (from.route.meta.backData) {
          this.subData.supplier_id = from.route.meta.backData.id;
          this.subData.supplier_name = from.route.meta.backData.name;

          this.getBatchNum({
            id: from.route.meta.backData.id,
            num: from.route.meta.backData.supplier_sn
          });
          // delete from.route.meta.backData  // 清空
        }
      }
      if (to.route.name == "manage_stock_addStock") {
        if (from.route.name == "manage_stock_addGoods") {
          //添加货品
          if (from.route.meta.backData) {
            let index = this.goodsIndex;
            if (!index) {
              this.subData.goods.push(JSON.parse(from.route.meta.backData));
            } else {
              let arr = this.subData.goods.slice();
              arr[index] = JSON.parse(from.route.meta.backData);
              this.subData.goods = arr;
              this.goodsIndex = "";
            }
          }
        } else if (from.route.name == "manage_stock_addAddition") {
          if (from.route.meta.backData) {
            // 附加费界面返回
            if (!this.editAddition) {
              this.subData.surcharge.market = this.subData.surcharge.market.concat(
                JSON.parse(from.route.meta.backData).market
              );
              this.subData.surcharge.place = this.subData.surcharge.place.concat(
                JSON.parse(from.route.meta.backData).place
              );
            } else {
              this.subData.surcharge = JSON.parse(from.route.meta.backData);
            }
          }
        }
      }
    });
  },
  beforeDestroy(){
    this.$toast.clear();
  },
  mounted() {},
  methods: {
    // 销售凭证
    //上传之前
    beforeReadBill(file, index) {

      this.$toast.loading({
        message: "上传中...",
        duration: 0,
        forbidClick: true
      });
      //图片上传
      photoCompress(file, res => {
        file = res;
        let fd = new FormData();
        fd.append("file[]", file);
        uploadImg(fd)
          .then(res => {
            this.$toast.clear();
            if (res.code == 200) {
              this.subData.bill_cert_imgs.push({
                url: res.data.resultInfo[0],
                isImage: true
              });
              return true;
            } else {
              return false;
            }
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast.fail("上传失败");
            return false;
          });
      });
    },
    // 产品证明
    //上传之前
    beforeReadProd(file, index) {
     
      this.$toast.loading({
        message: "上传中...",
        duration: 0,
        forbidClick: true
      });
      //图片上传
      photoCompress(file, res => {
        file = res;
        let fd = new FormData();
        fd.append("file[]", file);
        uploadImg(fd)
          .then(res => {
            this.$toast.clear();
            if (res.code == 200) {
              this.subData.prod_cert_imgs.push({
                url: res.data.resultInfo[0],
                isImage: true
              });
              return true;
            } else {
              return false;
            }
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast.fail("上传失败");
            return false;
          });
      });
    },
    /**
     * 删除图片
     */
    beforeDetaleCredit(file, index) {
      return true;
    },
    // 获取批次号
    getBatchNum(obj) {
      stock_new_batch(obj).then(res => {
        if (res.code == 200) {
          this.subData.batch = res.data.batchNum;
        }
      });
    },

    // 提交数据
    setData() {
      if (!this.subData.supplier_id) {
        this.$toast("请选择货主！");
        return false;
      }
      if (!this.subData.batch) {
        this.$toast("请输入批次号！");
        return false;
      }
         if (!/^[A-Za-z0-9]{1,30}$/g.test(this.subData.batch)) {
        this.$toast("请输入少于30位由字母或数字组成的批次号！");
        return false;
      }

      if (!String(this.subData.goods).length) {
        this.$toast("请输入货品！");
        return false;
      }
      this.$toast.loading({
        message: "加载中...",
        duration:0,
        forbidClick: true,
      });
      if(this.isQuery){
        return false;
      }
      this.isQuery=true;
      var subData = JSON.parse(JSON.stringify(this.subData));
      delete subData.supplier_name;
      subData.surcharge = subData.surcharge.market.concat(
        subData.surcharge.place
      );
      subData.goods = JSON.stringify(subData.goods);
      subData.surcharge = JSON.stringify(subData.surcharge);

      subData.bill_cert_imgs = subData.bill_cert_imgs.map(item => {
        return (item = item.url);
      });
      subData.prod_cert_imgs = subData.prod_cert_imgs.map(item => {
        return (item = item.url);
      });

      stock_new_create(subData).then(res => {
        if (res.code == 200) {
          this.$toast.success(res.message);
          this.isQuery=false;
          this.$router.go(-1);
        }
      }).catch(err=>{
        this.isQuery=false;
      });
    },

    //去添加商品或者修改
    toAddGoods(num) {
      
      if (!this.subData.supplier_name) {
        this.$toast("请先选择货主!");
        return false;
      }
      if (typeof num != "number") {
        this.$router.push({
          path: "/manage/stock/addGoods",
          query: {}
        });
      } else {
        this.goodsIndex = num + "";
        this.$router.push({
          path: "/manage/stock/addGoods",
          query: {
            type: "editGoods",
            goods: JSON.stringify(this.subData.goods[num])
          }
        });
      }
    },

    //去添加附加费或者修改
    toAddAddition(type, num) {
      
      if (!this.subData.supplier_name) {
        this.$toast("请先选择货主!");
        return false;
      }
      this.additionType = type; //附加费类型1：产地附加费  2：市场附加费
      if (type == "addAddition") {
        this.editAddition = false;
        this.$router.push({
          path: "/manage/stock/addAddition",
          query: {}
        });
      } else {
        this.editAddition = true;
        this.$router.push({
          path: "/manage/stock/addAddition",
          query: {
            surcharge: JSON.stringify(this.subData.surcharge)
          }
        });
      }
    },
    //删除所有附加费

    delAddition() {
       
      let tip = "";
      if (
        this.subData.surcharge.market.length &&
        this.subData.surcharge.place.length
      ) {
        tip = "市场和产地的";
      } else if (
        this.subData.surcharge.market.length &&
        !this.subData.surcharge.place.length
      ) {
        tip = "市场的";
      } else if (
        !this.subData.surcharge.market.length &&
        this.subData.surcharge.place.length
      ) {
        tip = "产地的";
      }
      this.$dialog
        .confirm({
          title: "删除附加费",
          message: `确定删除${tip}附加费吗?`
        })
        .then(() => {
          this.subData.surcharge = {
            market: [],
            place: []
          };
        })
        .catch(() => {
          // on cancel
        });
    },
    //删除货物
    delGoods(i) {
       
      this.$dialog
        .confirm({
          title: "删除货品",
          message: `确定删除${this.subData.goods[i].name}吗?`
        })
        .then(() => {
          let arr = this.subData.goods.slice();
          arr.splice(i, 1);
          this.subData.goods = arr;
        })
        .catch(() => {
          // on cancel
        });
    },

    // 去选择货主
    toSelectSupplier() {
      this.$router.push({
        path: "/manage/owner/ownerManage",
        query: {
          use_type: 1
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.addStock {
  position: relative;
  min-height: calc(100vh - 0.88rem);
  background-color: #fff;
  padding: 0 0.3rem 1.9rem;
  box-sizing: border-box;
  .img_title {
    font-size: 0.34rem;
    margin: 0.18rem 0;
  }
  & > div {
    overflow: hidden;
  }
  .addition_boxs {
    width: 6.9rem;
    box-sizing: border-box;
    margin: 0.2rem auto;
    padding: 0.31rem 0.3rem 0.3rem 0.31rem;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(49, 177, 88, 1);
    border-radius: 0.1rem;
    .addition_box {
      border-bottom: #ccc 1px solid;
      margin-bottom: 0.3rem;
      .addition_header {
        font-size: 0.36rem;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
    .addition_foot {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .addition_total {
        font-size: 0.32rem;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }
    .addition_list {
      padding: 0.15rem 0 0.25rem;
      .addition_item {
        display: flex;
        font-size: 0.28rem;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 0.36rem;
        margin: 0.05rem 0;
        justify-content: space-between;
        align-items: center;
        .addition_left {
          width: 1.57rem;
          flex-grow: 1;
          padding-left: 0.72rem;
        }
      }
    }
  }
  .add_btn_small {
    margin: 0.1rem 0;
    padding: 0 0.15rem;
    height: 0.6rem;
    line-height: 0.6rem;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(50, 178, 88, 1);
    border-radius: 0.06rem;
  }
  .good_label {
    font-size: 0.34rem;
    color: #333;
    line-height: 0.6rem;
    span {
      font-size: 0.28rem;
      color: #fb5353;
    }
  }
  .goods_btn {
    padding-bottom: 0.15rem;
    border-bottom: 0.01rem solid #e6e6e6;
    margin-bottom: 0.15rem;
    .goods_btns {
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      span {
        display: flex;
        align-items: center;
        height: 0.6rem;
        padding: 0 0.4rem;
        background-color: #e6e6e6;
        border-radius: 0.3rem;
        text-align: center;
        margin-right: 0.2rem;
        color: #999;
        letter-spacing: 0.05rem;
        margin-bottom: 0.1rem;
        &.active {
          background: rgba(49, 177, 88, 0.2);
          color: #31b158;
        }
      }
    }
  }
  .goods_batch_other {
    border-bottom: 0.01rem solid #e6e6e6;
    padding-bottom: 0.18rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .good_sel {
      font-size: 0.32rem;
    }
  }
  .goods_batch_type {
    padding-top: 0.18rem;
    margin-bottom: 0.18rem;
    .good_cli {
      font-size: 0.32rem;
      color: #999999;
      .van-icon-arrow {
        vertical-align: text-bottom;
      }
    }
  }
  .goods_input {
    padding-bottom: 0.2rem;
    .good_input {
      position: relative;
      box-sizing: border-box;
      height: 0.72rem;
      // background-color: #f5f5f5;
      overflow: hidden;
      border: 0.01rem solid #ccc;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input {
        width: 70%;
        line-height: 0.7rem;
        font-size: 0.34rem;
        text-indent: 0.2rem;
        border-radius: 0.1rem;
        // background-color: #f5f5f5;
        box-sizing: border-box;
      }
      span {
        line-height: 0.8rem;
        padding-right: 0.2rem;
      }
    }
  }
  .good_save {
    background-color: #31b158;
    text-align: center;
    line-height: 0.8rem;
    margin-top: 0.5rem;
    font-size: 0.36rem;
    color: #fff;
    letter-spacing: 0.1rem;
    border-radius: 0.1rem;
    &[disabled] {
      background-color: #b3b3b3;
    }
  }
  .good_type {
    padding: 0 0.18rem;
    height: 0.4rem;
    margin: 0.05rem 0;
    line-height: 0.4rem;
    border-radius: 0.2rem;
    display: inline-block;
    &.good_type_0 {
      background-color: #dafbdb;
      color: #4b9c64;
    }
    &.good_type_1 {
      background-color: #daeffb;
      color: #1d78c5;
    }
    &.good_type_2 {
      background-color: #fbedda;
      color: #bf8535;
    }
    img {
      width: 0.22rem;
      height: 0.22rem;
      margin-left: 0.1rem;
    }
  }
  .add_btn {
    font-size: 0.32rem;
    font-weight: 500;
    line-height: 0.7rem;
    color: rgba(50, 178, 88, 1);
    width: 6.9rem;
    height: 0.7rem;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(50, 178, 88, 1);
    border-radius: 0.06rem;
    margin: 0.2rem 0;
  }
  .goods_list {
    .goods {
      padding: 0.31rem 0.3rem 0.3rem 0.31rem;
      box-sizing: border-box;
      width: 6.9rem;
      border-radius: 0.1rem;
      margin: 0.15rem auto;
      background-color: #fff;
      border: 1px solid #31b158;
      .flex-b {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .goods_tips {
        line-height: 0.36rem;
        font-size: 0.28rem;
        margin-top: 0.2rem;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
        position: relative;
        .btns {
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      .goods_name {
        font-size: 0.36rem;
        font-weight: bold;
        margin-right: 0.22rem;
        color: rgba(51, 51, 51, 1);
      }
      .btns {
        display: flex;
        margin-top: 0.1rem;
        justify-content: flex-end;
      }
    }
  }
  .bottom_box {
    display: flex;
    box-shadow: 0px -1px 0px 0px rgba(230, 230, 230, 1);
    justify-content: space-between;
    align-items: center;
    height: 1.2rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    background-color: #fff;
    .bottom_text {
      flex-grow: 1;
      font-size: 0.36rem;
      line-height: 1.2rem;
      padding-left: 0.49rem;
      font-weight: bold;
      color: rgba(50, 178, 88, 1);
    }
    .good_save_btn {
      width: 2.2rem;
      height: 100%;
      flex-grow: 0;
      background: rgba(50, 178, 88, 1);
      font-size: 0.48rem;
      text-align: center;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 1.2rem;
      box-shadow: 1px 1px 0px 0px rgba(230, 230, 230, 1);
    }
  }
}
</style>